import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';

import './common/helpers/i18n.ts';
import './index.css';

import { init } from "@kalyzee/kast-web-sdk";
import { ToastContainer } from 'react-toastify';

init({ lang: "fr" });

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
    <ToastContainer position="top-right" pauseOnFocusLoss={false} draggable={false} pauseOnHover={false} className="toast-container" />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
